"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoneycombWebSDK = void 0;
const base_otel_sdk_1 = require("./base-otel-sdk");
const honeycomb_resource_1 = require("./honeycomb-resource");
const entry_page_resource_1 = require("./entry-page-resource");
const browser_attributes_resource_1 = require("./browser-attributes-resource");
const merge_resources_1 = require("./merge-resources");
const honeycomb_debug_1 = require("./honeycomb-debug");
const span_processor_builder_1 = require("./span-processor-builder");
const deterministic_sampler_1 = require("./deterministic-sampler");
const validate_options_1 = require("./validate-options");
const web_vitals_autoinstrumentation_1 = require("./web-vitals-autoinstrumentation");
class HoneycombWebSDK extends base_otel_sdk_1.WebSDK {
    constructor(options) {
        var _a;
        const instrumentations = [...((options === null || options === void 0 ? void 0 : options.instrumentations) || [])];
        // Automatically include web vitals instrumentation unless explicitly set to false
        if (((_a = options === null || options === void 0 ? void 0 : options.webVitalsInstrumentationConfig) === null || _a === void 0 ? void 0 : _a.enabled) !== false) {
            instrumentations.push(new web_vitals_autoinstrumentation_1.WebVitalsInstrumentation(options === null || options === void 0 ? void 0 : options.webVitalsInstrumentationConfig));
        }
        super(Object.assign(Object.assign({}, options), { instrumentations, resource: (0, merge_resources_1.mergeResources)([
                (0, browser_attributes_resource_1.configureBrowserAttributesResource)(),
                (0, entry_page_resource_1.configureEntryPageResource)(options === null || options === void 0 ? void 0 : options.entryPageAttributes),
                options === null || options === void 0 ? void 0 : options.resource,
                options === null || options === void 0 ? void 0 : options.resourceAttributes,
                (0, honeycomb_resource_1.configureHoneycombResource)(),
            ]), sampler: (0, deterministic_sampler_1.configureDeterministicSampler)(options), 
            // Exporter is configured through the span processor because
            // the base SDK does not allow having both a spanProcessor and a
            // traceExporter configured at the same time.
            spanProcessor: (0, span_processor_builder_1.configureSpanProcessors)(options) }));
        (0, validate_options_1.validateOptionsWarnings)(options);
        if (options === null || options === void 0 ? void 0 : options.debug) {
            (0, honeycomb_debug_1.configureDebug)(options);
        }
    }
}
exports.HoneycombWebSDK = HoneycombWebSDK;
